<template>
  <BoardView title="Pridėti žymą">
    <FormValidation @submit="create">
      <FormSnippet :snippet="snippet" />
      <Btn class="info" :isLoading="isSaving" type="submit">
        Sukurti žymą
      </Btn>
    </FormValidation>
  </BoardView>
</template>

<script>
import { actions, getters } from './utils'
import BoardView from 'components/board/BoardView'
import FormSnippet from './components/forms/FormSnippet'

export default {
  components: { BoardView, FormSnippet },
  data() {
    return {
      isSaving: false,
      snippet: this.$store.getters.snippetFactory(),
    }
  },
  computed: getters(),
  methods: {
    async create() {
      try {
        this.isSaving = true
        await this.CREATE_SNIPPET(this.snippet)
        this.$router.push({ name: 'AdminSnippets' })
      } finally {
        this.isSaving = false
      }
    },
    ...actions('CREATE_SNIPPET'),
  },
}
</script>
